import { z } from "zod";

/**
 * Binary response endpoint
 * GenerateFile returns a Word document buffer via @Res()
 */

export const DocumentTemplateGenerateFileBodySchema = z.object({
  content: z.string(),
  fileName: z.string(),
  formatTemplateId: z.string()
});
